/* eslint-disable @typescript-eslint/no-explicit-any */
import { Controller, useFormContext } from 'react-hook-form'
import { GridRowModel, GridRowsProp } from '@mui/x-data-grid-pro'
import { useEffect } from 'react'
import Table from '@/shared/components/Table/Table'
import { TABLE_KEYS } from '../../models/Filter.model'
import styles from './TableField.module.scss'

interface TableFieldProps {
  name: string
  columns: any[]
  tableKey: TABLE_KEYS
  defaultRows?: GridRowsProp
  editable?: boolean
  columnVisibilityModel?: Record<string, boolean>
}

export function TableField({
  name,
  columns,
  tableKey,
  defaultRows = [],
  editable = true,
  columnVisibilityModel
}: TableFieldProps) {
  const { control, setValue, getValues, getFieldState } = useFormContext()

  useEffect(() => {
    const currentValue = getValues(name)
    const isDirty = getFieldState(name).isDirty
    const hasCurrentRows =
      Array.isArray(currentValue) && currentValue.length > 0

    if (!isDirty || !hasCurrentRows) {
      setValue(name, defaultRows, { shouldDirty: true, shouldValidate: false })
    }
  }, [defaultRows, name, setValue, getValues, getFieldState])

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultRows}
      render={({ field, fieldState }) => (
        <div className={styles.tableFiledWrapper}>
          <Table
            columns={columns}
            tableKey={tableKey}
            initialRows={field.value}
            filterModel={{ items: [] }}
            hideRowFilter
            hideToolbar={!editable}
            hideActionsButtons
            hideCheckboxSelection
            onRowsChange={(updatedRows: GridRowModel[]) =>
              field.onChange(updatedRows)
            }
            columnVisibilityModel={columnVisibilityModel}
          />
          {fieldState.error && (
            <p style={{ color: 'red', marginTop: 4 }}>
              {fieldState.error.message}
            </p>
          )}
        </div>
      )}
    />
  )
}
